/* 123custom redesign: scroll reveal, product tabs, play videos only when visible. */
(function () {
  'use strict';
  window.rdReady = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  function sectionElements(root, selector) {
    var elements = Array.prototype.slice.call(root.querySelectorAll(selector));
    if (root.matches && root.matches(selector)) elements.unshift(root);
    return elements;
  }

  // Scroll reveal. Elements start hidden only because <html> has .rd-js (set inline in the head).
  var io;
  if (hasIO && !reduce) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('rd-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  }
  function reveal(root) {
    sectionElements(root, '.rd-rv').forEach(function (el) {
      if (io) io.observe(el);
      else el.classList.add('rd-in');
    });
  }
  reveal(document);

  // Back link: go back in history when the visitor came from this shop, else follow the link.
  document.querySelectorAll('[data-rd-back]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      try {
        var referrer = document.referrer && new URL(document.referrer);
        var designer = referrer && /\/(?:design|designer|embed)(?:\/|$)/i.test(referrer.pathname);
        if (referrer && referrer.origin === location.origin && !designer && history.length > 1) {
          e.preventDefault();
          history.back();
        }
      } catch (err) {}
    });
  });

  // Tabs (bestsellers). Arrow keys move between tabs, as the ARIA tabs pattern expects.
  var tabCleanup = new WeakMap();
  function initTabs(root) {
    if (tabCleanup.has(root)) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var cleanup = [];
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (t, i) {
      function click() { select(t, false); }
      function keydown(e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); select(tabs[(i + 1) % tabs.length], true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); select(tabs[(i - 1 + tabs.length) % tabs.length], true); }
      }
      t.addEventListener('click', click);
      t.addEventListener('keydown', keydown);
      cleanup.push(function () {
        t.removeEventListener('click', click);
        t.removeEventListener('keydown', keydown);
      });
    });
    tabCleanup.set(root, function () { cleanup.forEach(function (remove) { remove(); }); });
  }
  document.querySelectorAll('[data-rd-tabs]').forEach(initTabs);

  document.addEventListener('shopify:section:load', function (e) {
    reveal(e.target);
    sectionElements(e.target, '[data-rd-tabs]').forEach(initTabs);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (io) sectionElements(e.target, '.rd-rv').forEach(function (el) { io.unobserve(el); });
    sectionElements(e.target, '[data-rd-tabs]').forEach(function (root) {
      var cleanup = tabCleanup.get(root);
      if (cleanup) cleanup();
      tabCleanup.delete(root);
    });
  });

  // Videos: muted loops that load and play only once on screen, pause when off screen.
  var vids = document.querySelectorAll('video[data-rd-autoplay]');
  if (vids.length && hasIO && !reduce) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { vio.observe(v); });
  } else {
    vids.forEach(function (v) { v.controls = true; });
  }
})();
